<!-- TrustBox widget - Micro Combo -->
<div
  *appFeatureFlag="'isTrustpilotAvailable'"
  #trustbox
  class="trustpilot-widget"
  data-locale="en-GB"
  data-template-id="5419b6ffb0d04a076446a9af"
  data-businessunit-id="6a9689d98716e8b55449b156"
  data-style-height="20px"
  data-style-width="100%"
  [attr.data-theme]="theme"
>
  <a href="https://uk.trustpilot.com/review/www.identi.pet" target="_blank" rel="noopener">
    Trustpilot
  </a>
</div>
<!-- End TrustBox widget -->
